import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel", "chevron", "topRow"]
  static values = { expanded: { type: Boolean, default: false } }

  connect() {
    this.sync()
  }

  toggle(event) {
    event?.preventDefault()
    this.expandedValue = !this.expandedValue
  }

  keydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.toggle(event)
    }
  }

  expandedValueChanged() {
    this.sync()
  }

  sync() {
    const expanded = this.expandedValue

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", String(expanded))
      this.toggleTarget.setAttribute(
        "aria-label",
        expanded ? "Hide quiz accuracy details" : "Show quiz accuracy details"
      )
    }

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", !expanded)
      this.panelTarget.setAttribute("aria-hidden", String(!expanded))
      if (expanded) {
        this.panelTarget.removeAttribute("inert")
      } else {
        this.panelTarget.setAttribute("inert", "")
      }
    }

    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", expanded)
    }

    if (this.hasTopRowTarget) {
      this.topRowTarget.classList.toggle("rounded-b-[var(--ds-radius-lg)]", !expanded)
    }
  }
}
